/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BlockingStateDto } from './BlockingStateDto';
import {
    BlockingStateDtoFromJSON,
    BlockingStateDtoFromJSONTyped,
    BlockingStateDtoToJSON,
    BlockingStateDtoToJSONTyped,
} from './BlockingStateDto';
import type { NotificationResponse } from './NotificationResponse';
import {
    NotificationResponseFromJSON,
    NotificationResponseFromJSONTyped,
    NotificationResponseToJSON,
    NotificationResponseToJSONTyped,
} from './NotificationResponse';

/**
 * 
 * @export
 * @interface CreateOrUpdateEmprunteurPersonneResponse
 */
export interface CreateOrUpdateEmprunteurPersonneResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateEmprunteurPersonneResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEmprunteurPersonneResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateEmprunteurPersonneResponse
     */
    id?: string;
    /**
     * 
     * @type {NotificationResponse}
     * @memberof CreateOrUpdateEmprunteurPersonneResponse
     */
    notification?: NotificationResponse;
    /**
     * Information de blocage (ex. profession à risque -> devis annulé). ABSENT du JSON quand l'opération s'est déroulée normalement.
     * 
     * @type {BlockingStateDto}
     * @memberof CreateOrUpdateEmprunteurPersonneResponse
     */
    blockingState?: BlockingStateDto | null;
}

/**
 * Check if a given object implements the CreateOrUpdateEmprunteurPersonneResponse interface.
 */
export function instanceOfCreateOrUpdateEmprunteurPersonneResponse(value: object): value is CreateOrUpdateEmprunteurPersonneResponse {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    return true;
}

export function CreateOrUpdateEmprunteurPersonneResponseFromJSON(json: any): CreateOrUpdateEmprunteurPersonneResponse {
    return CreateOrUpdateEmprunteurPersonneResponseFromJSONTyped(json, false);
}

export function CreateOrUpdateEmprunteurPersonneResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateEmprunteurPersonneResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'id': json['id'] == null ? undefined : json['id'],
        'notification': json['notification'] == null ? undefined : NotificationResponseFromJSON(json['notification']),
        'blockingState': json['blockingState'] == null ? undefined : BlockingStateDtoFromJSON(json['blockingState']),
    };
}

export function CreateOrUpdateEmprunteurPersonneResponseToJSON(json: any): CreateOrUpdateEmprunteurPersonneResponse {
    return CreateOrUpdateEmprunteurPersonneResponseToJSONTyped(json, false);
}

export function CreateOrUpdateEmprunteurPersonneResponseToJSONTyped(value?: CreateOrUpdateEmprunteurPersonneResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'id': value['id'],
        'notification': NotificationResponseToJSON(value['notification']),
        'blockingState': BlockingStateDtoToJSON(value['blockingState']),
    };
}

